import { useEffect } from "react";
import { useKeyPressOnce } from "../../Map/components/MapEventHandler/useKey";
import { inputsActions } from "../..";
import { useSelector, useDispatch } from "react-redux";

const HandleFeatureIdentity = ({ feature }) => {
  const dispatch = useDispatch();
  const selectedFeatureId = useSelector((state) => state.inputs.selectedFeatureId);
  const selected_feature = useSelector((state) => state.inputs.site_features[selectedFeatureId]);
  const isMultiSelect = Array.isArray(selectedFeatureId);

  const boundaryKey = useKeyPressOnce("b");
  const exclusionKey = useKeyPressOnce("e");
  const inactiveKey = useKeyPressOnce("i");

  useEffect(() => {
    // Only trigger when a key is actually pressed
    if (!boundaryKey && !exclusionKey && !inactiveKey) return;

    console.log("Hotkey pressed - boundaryKey:", boundaryKey, "exclusionKey:", exclusionKey, "inactiveKey:", inactiveKey);
    console.log("selectedFeatureId:", selectedFeatureId);
    console.log("isMultiSelect:", isMultiSelect);

    // For multi-select, we need at least one selected feature
    // For single select, we need the selected feature to exist
    if (!selectedFeatureId || (!isMultiSelect && !selected_feature)) {
      console.log("Early return: no selectedFeatureId or no selected_feature");
      return;
    }

    // For single select, ensure the feature matches
    if (!isMultiSelect && feature && selectedFeatureId !== feature.properties.index) {
      console.log("Early return: feature mismatch");
      return;
    }

    // If the user is focused in an input/textarea/select or editing content, don't react to map hotkeys
    const active = document && document.activeElement;
    const tag = active && active.tagName && active.tagName.toUpperCase();
    const isEditingField = tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT" || (active && active.isContentEditable);

    if (isEditingField) {
      console.log("Early return: editing field");
      return;
    }

    if (boundaryKey) {
      console.log("Boundary key pressed, calling updateIdentity(1)");
      updateIdentity(1);
    }
    if (exclusionKey) {
      console.log("Exclusion key pressed, calling updateIdentity(2)");
      updateIdentity(2);
    }
    if (inactiveKey) {
      console.log("Inactive key pressed, calling updateIdentity(0)");
      updateIdentity(0);
    }
  }, [boundaryKey, exclusionKey, inactiveKey]);

  const updateIdentity = (identity) => {
    console.log("isMultiSelect:", isMultiSelect);
    console.log("selectedFeatureId:", selectedFeatureId);
    console.log("selected_feature:", selected_feature);

    if (isMultiSelect) {
      // Bulk update all selected features
      dispatch(
        inputsActions.update_site_input("bulk_update_identity", {
          featureIds: selectedFeatureId,
          identity: identity,
        }),
      );
    } else {
      // Single feature update
      const updatedFeature = {
        ...selected_feature,
        properties: {
          ...selected_feature.properties,
          identity,
          active: identity !== 0 || !selected_feature.properties.active,
        },
      };

      dispatch(inputsActions.update_site_input("edit_site_feature", updatedFeature));
    }
  };

  return null;
};

export { HandleFeatureIdentity };
